// src/components/rcv/VisualizadorDocumento.jsx
import React, { useState, useEffect } from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Box,
  Button,
  CircularProgress
} from '@mui/material';
import { PictureAsPdf, Close } from '@mui/icons-material';
import { dtedocService } from '../../services/dtedocService';
import SimplePdfViewer from './SimplePdfViewer';

const VisualizadorDocumento = ({ documento, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    cargarPdf();
    
    // Limpieza al desmontar
    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [documento?.id]);

  const cargarPdf = async () => {
    if (!documento) {
      setError("No hay documento para visualizar");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      const blob = await dtedocService.getDocumentoPdf(documento.id);
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);
    } catch (err) {
      console.error("Error al cargar PDF:", err);
      setError(err.message || "Error al cargar el PDF del documento");
    } finally {
      setLoading(false);
    }
  };

  const handleDescargarPdf = async () => {
    if (!documento) return;
    
    try {
      await dtedocService.downloadDocumento(documento.id, 'pdf');
    } catch (err) {
      console.error("Error al descargar PDF:", err);
      setError(err.message || "Error al descargar el PDF");
    }
  };

  return (
    <>
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">
            Visualización de Documento
          </Typography>
          <IconButton edge="end" onClick={onClose} aria-label="cerrar">
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0, overflow: 'hidden' }}>
        {loading ? (
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100%'
          }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100%',
            p: 3
          }}>
            <Typography variant="h6" color="error" gutterBottom>
              Error al cargar el documento
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {error}
            </Typography>
          </Box>
        ) : pdfUrl ? (
          <SimplePdfViewer pdfUrl={pdfUrl} />
        ) : (
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100%' 
          }}>
            <Typography variant="body1">
              No se encontró ningún documento para visualizar
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between', px: 3, py: 2 }}>
        <Box>
          {documento && (
            <Typography variant="caption" color="text.secondary">
              ID: {documento.id} • Tipo: {documento.tipo_doc} • Folio: {documento.folio}
            </Typography>
          )}
        </Box>
        <Button
          onClick={handleDescargarPdf}
          variant="contained"
          startIcon={<PictureAsPdf />}
          disabled={!documento || loading}
        >
          Descargar PDF
        </Button>
      </DialogActions>
    </>
  );
};

export default VisualizadorDocumento;